import requireAuthContext from '../../authorization/requireAuthContext'
import trackingService from './TrackingService'

const postTrackingEvent = async (
  category: string,
  action: string,
  payload: Record<string, unknown>,
  assetId: string
) => {
  const authContext = await requireAuthContext()
  await trackingService.postTrackingEvent({
    category,
    action,
    payload,
    userEntityId: authContext.userEntityId,
    organizationId: authContext.organizationId,
    assetId,
  })
}

export default postTrackingEvent
